import { render, staticRenderFns } from "./trip-operation-table.vue?vue&type=template&id=0ca148ae&scoped=true&"
import script from "./trip-operation-table.vue?vue&type=script&lang=js&"
export * from "./trip-operation-table.vue?vue&type=script&lang=js&"
import style0 from "./trip-operation-table.vue?vue&type=style&index=0&id=0ca148ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca148ae",
  null
  
)

export default component.exports